import { useRef, useState } from "react";
import { useOnClickOutside } from "../../common/hooks/useOnClickOutside";
import { useSharedStateWriteOnly } from "../app/useSharedState";
import "./ContextMenuBase.css";

export type TContextMenuItem = {
  label: string;
  action?: () => void;
  children?: TContextMenuItem[];
};

type TProps = {
  items: TContextMenuItem[];
  anchorRight: number;
  anchorTop: number;
  anchorLeft?: number;
};

export function ContextMenuBase({
  items,
  anchorRight,
  anchorTop,
  anchorLeft = anchorRight,
}: TProps) {
  const [, setActiveContextMenu] = useSharedStateWriteOnly("activeContextMenu");

  const [hoveredItem, setHoveredItem] = useState<number | null>(null);

  const rootRef = useRef<HTMLDivElement | null>(null);
  useOnClickOutside([rootRef], () => {
    setActiveContextMenu(null);
  });

  let childrenMenu = null;
  if (
    rootRef.current !== null &&
    hoveredItem !== null &&
    items[hoveredItem].children !== undefined
  ) {
    const itemBounds =
      rootRef.current.children[hoveredItem].getBoundingClientRect();
    childrenMenu = (
      <ContextMenuBase
        items={items[hoveredItem].children}
        anchorRight={itemBounds.right}
        anchorTop={itemBounds.top}
        anchorLeft={itemBounds.left}
      />
    );
  }

  return (
    <div
      style={{ position: "fixed", left: anchorRight, top: anchorTop }}
      ref={rootRef}
      onContextMenu={(e) => {
        e.preventDefault();
      }}
      onPointerLeave={() => {
        if (hoveredItem !== null && items[hoveredItem].children === undefined) {
          setHoveredItem(null);
        }
      }}
    >
      {items.map((v, i) => (
        <div
          className="context-menu-base-item"
          onPointerOver={() => {
            setHoveredItem(i);
          }}
          onPointerUp={
            v.action === undefined
              ? undefined
              : (e) => {
                  console.log(e.button);
                  if (e.button === 0) {
                    v.action!();
                    setActiveContextMenu(null);
                  }
                }
          }
        >
          {v.label}
        </div>
      ))}
      {childrenMenu}
    </div>
  );
}
